/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Copyright All Rights Reserved
 */

import React from 'react';
import PropTypes from 'prop-types';
import ReportRow from 'components/ReportRow';

const ReportsTable = props => (
  <div className="table">
    <div className="row table-header">
      <div className="col-md-1">File</div>
      <div className="col-md-3">Name</div>
      <div className="col-md-4">Address</div>
      <div className="col-md-2">Created By</div>
      <div className="col-md-2">Date Created</div>
    </div>
    {props.reports.map(report =>
      <ReportRow key={report.id} report={report} />
    )}
  </div>
);

ReportsTable.propTypes = {
  reports: PropTypes.arrayOf(
    PropTypes.shape(ReportRow.propTypes.report)
  ).isRequired,
};

export default ReportsTable;
